// main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';

import { appConfig } from './app/app.config'; // Tu configuración existente (router, zone, etc.)

async function main() {
  await bootstrapApplication(AppComponent, {
    providers: [
      ...appConfig.providers!,
      // HttpClient si no lo tienes aún en appConfig
      provideHttpClient(),
    ],
  });
}

main().catch(err => console.error(err));
